module.exports = __webpack_public_path__ + "static/media/santiago_beltran.726a94ff.jpg";